// some functinality of this team filter depand on portfolio JS

$(() => {
  let teamSectionTitle = $(
    ".team-posts-taxonomy-section .grid-item .section-name"
  );

  // Each Checkbox filter clear
  $("#selected-filters .selected-filters--sectors")
    .add("#selected-filters .selected-filters--region")
    .on("click", "span", function () {
      let dataSlug = $(this).attr("data-checkslug");
      let dynamicCheckBox = $(
        `.team-posts-filter-section .checkbox-group input[data-checkslug="${dataSlug}"]`
      );
      $(dynamicCheckBox).click();
    });

  $(teamSectionTitle).each((index, element) => {
    const title = $(element).text();

    let text_array = title.split(" ");

    for (i = 0; i < text_array.length; i++) {
      if (i == text_array.length - 1) {
        text_array[i] = "<span>" + text_array[i] + "</span>";
      } else {
        text_array[i] = text_array[i] + " ";
      }
    }

    $(element).html(text_array.join(""));
  });
 
});
